/* Velnique theme scripts */
(function () {
  'use strict';

  const $ = (sel, ctx = document) => ctx.querySelector(sel);
  const $$ = (sel, ctx = document) => Array.from(ctx.querySelectorAll(sel));

  /* ---------- Announcement rotation ---------- */
  function initAnnouncements() {
    $$('[data-announcement]').forEach((bar) => {
      const msgs = $$('.announcement__msg', bar);
      if (msgs.length < 2) return;
      let i = 0;
      const speed = (parseInt(bar.dataset.speed, 10) || 5) * 1000;
      setInterval(() => {
        msgs[i].classList.remove('is-active');
        i = (i + 1) % msgs.length;
        msgs[i].classList.add('is-active');
      }, speed);
    });
  }

  /* ---------- Drawers ---------- */
  function openDrawer(drawer) {
    if (!drawer) return;
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.classList.add('is-locked');
    const focusable = drawer.querySelector('button, a, input');
    if (focusable) setTimeout(() => focusable.focus(), 50);
  }
  function closeDrawer(drawer) {
    if (!drawer) return;
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('is-locked');
  }

  function initMenu() {
    const menu = $('[data-mobile-menu]');
    document.addEventListener('click', (e) => {
      if (e.target.closest('[data-menu-open]')) { openDrawer(menu); }
      if (e.target.closest('[data-menu-close]')) { closeDrawer(menu); }
      if (e.target.closest('[data-cart-close]')) { closeDrawer($('[data-cart-drawer]')); }
    });
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') { $$('.drawer.is-open').forEach(closeDrawer); }
    });
  }

  function initSearch() {
    const panel = $('[data-search-panel]');
    if (!panel) return;
    document.addEventListener('click', (e) => {
      const open = e.target.closest('[data-search-open]');
      if (open) {
        e.preventDefault();
        panel.hidden = !panel.hidden;
        if (!panel.hidden) $('input[type="search"]', panel).focus();
      }
      if (e.target.closest('[data-search-close]')) panel.hidden = true;
    });
  }

  /* ---------- Sliders ---------- */
  function initSliders(ctx = document) {
    $$('[data-slider]', ctx).forEach((slider) => {
      const track = $('[data-slider-track]', slider);
      const prev = $('[data-slider-prev]', slider);
      const next = $('[data-slider-next]', slider);
      const bar = $('[data-slider-progress]', slider);
      if (!track) return;
      const step = () => {
        const item = track.children[0];
        return item ? item.getBoundingClientRect().width + parseFloat(getComputedStyle(track).columnGap || 0) : track.clientWidth;
      };
      const update = () => {
        const max = track.scrollWidth - track.clientWidth;
        const controls = slider.querySelector('.slider__controls');
        if (controls) controls.style.display = max <= 2 ? 'none' : '';
        if (prev) prev.disabled = track.scrollLeft <= 2;
        if (next) next.disabled = track.scrollLeft >= max - 2;
        if (bar) {
          const ratio = track.clientWidth / track.scrollWidth;
          const pos = max > 0 ? track.scrollLeft / max : 0;
          bar.style.width = (ratio * 100) + '%';
          bar.style.transform = 'translateX(' + (pos * (1 / ratio - 1) * 100) + '%)';
        }
      };
      prev && prev.addEventListener('click', () => track.scrollBy({ left: -step(), behavior: 'smooth' }));
      next && next.addEventListener('click', () => track.scrollBy({ left: step(), behavior: 'smooth' }));
      track.addEventListener('scroll', update, { passive: true });
      window.addEventListener('resize', update);
      update();
    });
  }

  /* ---------- Money ---------- */
  function formatMoney(cents) {
    const format = (window.velnique && window.velnique.moneyFormat) || '{{amount}}';
    const value = (cents / 100);
    const withDelims = (n, dec, thou, sep) => {
      const parts = n.toFixed(dec).split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thou);
      return parts.join(sep);
    };
    return format.replace(/\{\{\s*(\w+)\s*\}\}/, (_, key) => {
      switch (key) {
        case 'amount_no_decimals': return withDelims(value, 0, ',', '.');
        case 'amount_with_comma_separator': return withDelims(value, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return withDelims(value, 0, '.', ',');
        case 'amount_with_space_separator': return withDelims(value, 2, ' ', ',');
        default: return withDelims(value, 2, ',', '.');
      }
    });
  }

  /* ---------- Cart ---------- */
  async function refreshCart(sectionsHtml) {
    let html = sectionsHtml && sectionsHtml['cart-drawer'];
    if (!html) {
      const res = await fetch(window.routes.root_url.replace(/\/$/, '') + '/?sections=cart-drawer');
      const json = await res.json();
      html = json['cart-drawer'];
    }
    const current = $('[data-cart-drawer]');
    if (html && current) {
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const fresh = $('[data-cart-drawer]', doc);
      if (fresh) {
        const wasOpen = current.classList.contains('is-open');
        current.innerHTML = fresh.innerHTML;
        if (wasOpen) current.classList.add('is-open');
      }
    }
    const cart = await (await fetch(window.routes.cart_url + '.js')).json();
    $$('[data-cart-count]').forEach((el) => {
      el.textContent = cart.item_count;
      el.classList.toggle('is-empty', cart.item_count === 0);
    });
    return cart;
  }

  function useDrawer() {
    return window.velnique && window.velnique.cartType === 'drawer' && $('[data-cart-drawer]');
  }

  function initAddToCart() {
    document.addEventListener('submit', async (e) => {
      const form = e.target.closest('[data-product-form]');
      if (!form || !useDrawer()) return;
      e.preventDefault();
      const btn = form.querySelector('[type="submit"]');
      const errorEl = form.querySelector('[data-form-error]');
      if (btn) btn.classList.add('is-loading');
      if (errorEl) errorEl.hidden = true;
      try {
        const body = new FormData(form);
        body.append('sections', 'cart-drawer');
        body.append('sections_url', window.location.pathname);
        const res = await fetch(window.routes.cart_add_url + '.js', {
          method: 'POST',
          headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/json' },
          body
        });
        const data = await res.json();
        if (!res.ok || data.status) {
          if (errorEl) { errorEl.textContent = data.description || data.message || 'Could not add to bag.'; errorEl.hidden = false; }
          return;
        }
        await refreshCart(data.sections);
        openDrawer($('[data-cart-drawer]'));
      } catch (err) {
        form.submit();
      } finally {
        if (btn) btn.classList.remove('is-loading');
      }
    });

    document.addEventListener('click', async (e) => {
      const opener = e.target.closest('[data-cart-open]');
      if (opener && useDrawer()) {
        e.preventDefault();
        openDrawer($('[data-cart-drawer]'));
        return;
      }
      const change = e.target.closest('[data-line-change]');
      if (change) {
        e.preventDefault();
        const line = parseInt(change.dataset.lineChange, 10);
        const quantity = Math.max(0, parseInt(change.dataset.qty, 10));
        change.closest('.cart-line') && (change.closest('.cart-line').style.opacity = '.5');
        const res = await fetch(window.routes.cart_change_url + '.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ line, quantity, sections: 'cart-drawer', sections_url: window.location.pathname })
        });
        const data = await res.json();
        if (document.body.classList.contains('template-cart')) { window.location.reload(); return; }
        await refreshCart(data.sections);
      }
    });
  }

  /* ---------- Product ---------- */
  function initProduct(section) {
    const gallery = $('[data-gallery]', section);
    const showMedia = (id) => {
      if (!gallery || !id) return;
      $$('.product__slide', gallery).forEach((s) => s.classList.toggle('is-active', s.dataset.mediaId == id));
      $$('[data-thumb]', gallery).forEach((t) => t.classList.toggle('is-active', t.dataset.thumb == id));
    };
    if (gallery) {
      gallery.addEventListener('click', (e) => {
        const thumb = e.target.closest('[data-thumb]');
        if (thumb) showMedia(thumb.dataset.thumb);
      });
    }

    // Quantity
    $$('[data-qty]', section).forEach((wrap) => {
      const input = $('input', wrap);
      if (!input) return;
      wrap.addEventListener('click', (e) => {
        if (e.target.closest('[data-qty-minus]')) input.value = Math.max(1, (parseInt(input.value, 10) || 1) - 1);
        if (e.target.closest('[data-qty-plus]')) input.value = (parseInt(input.value, 10) || 1) + 1;
      });
    });

    // Variants
    const picker = $('[data-variant-picker]', section);
    if (picker) {
      const variants = JSON.parse($('[data-variants]', picker).textContent);
      picker.addEventListener('change', () => {
        const selected = $$('fieldset', picker).map((fs) => {
          const checked = $('input:checked', fs);
          return checked ? checked.value : null;
        });
        $$('[data-option-value]', picker).forEach((el, i) => { el.textContent = selected[i]; });
        const variant = variants.find((v) => v.options.every((o, i) => o === selected[i]));
        const idInput = $('[data-variant-id]', section);
        const addBtn = $('[data-add-button]', section);
        const label = $('[data-add-label]', section);
        if (!variant) {
          if (addBtn) addBtn.disabled = true;
          return;
        }
        if (idInput) idInput.value = variant.id;
        if (addBtn) addBtn.disabled = !variant.available;
        if (label && addBtn) label.textContent = variant.available ? addBtn.dataset.addText : addBtn.dataset.soldText;
        const priceEl = $('[data-price]', section);
        if (priceEl) priceEl.textContent = formatMoney(variant.price);
        const cmp = $('[data-compare-price]', section);
        if (cmp) cmp.textContent = variant.compare_at_price > variant.price ? formatMoney(variant.compare_at_price) : '';
        const sticky = $('[data-sticky-price]', section);
        if (sticky) sticky.textContent = formatMoney(variant.price);
        if (variant.featured_media) showMedia(variant.featured_media.id);
        const url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url.toString());
      });
    }

    // Sticky add to cart
    const sticky = $('[data-sticky-atc]', section);
    const buy = $('.product__buy', section);
    if (sticky && buy && 'IntersectionObserver' in window) {
      sticky.hidden = false;
      new IntersectionObserver(([entry]) => {
        sticky.classList.toggle('is-visible', !entry.isIntersecting && entry.boundingClientRect.top < 0);
      }).observe(buy);
      $('[data-sticky-add]', sticky).addEventListener('click', () => {
        const form = $('[data-product-form]', section);
        if (form) form.requestSubmit ? form.requestSubmit() : form.submit();
      });
    }
  }

  /* ---------- Recommendations ---------- */
  function initRecommendations() {
    $$('[data-recommendations]').forEach(async (el) => {
      if (el.children.length) return;
      try {
        const res = await fetch(el.dataset.url);
        const html = await res.text();
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const fresh = $('[data-recommendations]', doc);
        if (fresh && fresh.innerHTML.trim()) el.innerHTML = fresh.innerHTML;
      } catch (e) { /* silent */ }
    });
  }

  /* ---------- Account: recover password toggle ---------- */
  function initRecover() {
    const login = $('[data-login-view]');
    const recover = $('[data-recover-view]');
    if (!login || !recover) return;
    const show = (r) => { recover.hidden = !r; login.hidden = r; };
    if (window.location.hash === '#recover') show(true);
    document.addEventListener('click', (e) => {
      if (e.target.closest('[data-show-recover]')) { e.preventDefault(); show(true); }
      if (e.target.closest('[data-hide-recover]')) { e.preventDefault(); show(false); }
    });
  }

  /* ---------- Theme editor support ---------- */
  document.addEventListener('shopify:section:load', (e) => {
    initSliders(e.target);
    const p = $('[data-product-section]', e.target);
    if (p) initProduct(p);
  });

  document.addEventListener('DOMContentLoaded', () => {
    initAnnouncements();
    initMenu();
    initSearch();
    initSliders();
    initAddToCart();
    $$('[data-product-section]').forEach(initProduct);
    initRecommendations();
    initRecover();
  });
})();
